import React from "react";
import classes from "./RnDoffers.module.css";
import kids from "../../assets/vector/kids.png";
import school from "../../assets/vector/school.png";
import college from "../../assets/vector/college.png";
import RnDOffer from "./RnDOffer";

const RnDOffers = () => {
  const kidsOffers = [
    "Play-based STEM activities",
    "Curiosity-driven experiments",
    "Fun coding games",
  ];

  const schoolOffers = [
    "Science/Math till Class 10",
    "Engineering/Medical (Class 11/12)",
    "Career Counseling & Guidance",
  ];

  const collegeOffers = [
    "IT & Research Projects",
    "Internships & Industry Mentorship",
    "Career Counseling & Guidance",
  ];

  return (
    <section
      className={classes.offersSection}
      aria-label="R&D Mentorship Programs"
    >
      <div className={classes.offersBox}>
        <RnDOffer
          offerTitle="Kids"
          offerImage={kids}
          altImg="Kids learning STEM"
          offerArr={kidsOffers}
        />

        <RnDOffer
          offerTitle="School Students"
          offerImage={school}
          altImg="School students education"
          offerArr={schoolOffers}
        />

        <RnDOffer
          offerTitle="College Students"
          offerImage={college}
          altImg="College students research"
          offerArr={collegeOffers}
        />
      </div>
    </section>
  );
};

export default RnDOffers;
